// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import Select from "@insite/mobius/Select";
// eslint-disable-next-line spire/fenced-imports
import StandardControl from "@insite/shell-public/Components/StandardControl";
// eslint-disable-next-line spire/fenced-imports
import {
    CustomEditorTemplateProps,
    HorizontalAlignment,
    HorizontalAlignmentDefinition,
} from "@awc/CustomFieldDefinition";
import * as React from "react";
import styled from "styled-components";

type Props = CustomEditorTemplateProps<HorizontalAlignment[], HorizontalAlignmentDefinition>;
export default class HorizontalAlignmentField extends React.Component<Props> {
    updateHorizontal = (index: number, value: HorizontalAlignment) => {
        const {
            fieldValue,
            updateField,
            fieldDefinition: { name },
        } = this.props;
        const newFieldValue = { ...fieldValue };
        newFieldValue[index] = value;
        updateField(name, newFieldValue);
    };
    render() {
        const { item, fieldDefinition, fieldValue } = this.props;
        const columns = item.fields["columns"];
        if (!columns || !Array.isArray(columns)) {
            return null;
        }
        if (!fieldValue) {
            this.props.updateField(fieldDefinition.name, []);
            return null;
        }
        return (
            <StandardControl fieldDefinition={fieldDefinition as any}>
                {columns.map((column, index) => (
                    <HorizontalAlignmentSelector
                        key={index}
                        index={index}
                        updateHorizontal={this.updateHorizontal}
                        value={fieldValue[index] || ""}
                    />
                ))}
            </StandardControl>
        );
    }
}
interface SelectorProps {
    value: HorizontalAlignment;
    index: number;
    updateHorizontal: (index: number, value: HorizontalAlignment) => void;
}
class HorizontalAlignmentSelector extends React.Component<SelectorProps> {
    onChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.props.updateHorizontal(this.props.index, event.currentTarget.value as HorizontalAlignment);
    };
    render() {
        const { index, value } = this.props;
        return (
            <Wrapper>
                <span>{index + 1}</span>
                <Select onChange={this.onChange} value={value}>
                    <option value="">Select Value</option>
                    <option value="left">Left</option>
                    <option value="center">Center</option>
                    <option value="right">Right</option>
                </Select>
            </Wrapper>
        );
    }
}
const Wrapper = styled.div`
    display: flex;
    align-items: center;
    > span {
        margin: 10px 5px 0 0;
    }
`;
